/* ═══════════════════════════════════════════════
   HOMELAND PEPTIDES — THEME JS v2.0
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── DISCLAIMER ─── */
  var agreeBtn = document.getElementById('agreeBtn');
  var modal    = document.getElementById('disclaimer');
  if (agreeBtn && modal) {
    if (sessionStorage.getItem('hlp_agreed')) {
      modal.style.display = 'none';
    }
    agreeBtn.addEventListener('click', function () {
      modal.style.display = 'none';
      sessionStorage.setItem('hlp_agreed', '1');
    });
  }

  /* ─── STARFIELD ─── */
  var starsEl = document.getElementById('stars');
  if (starsEl) {
    for (var i = 0; i < 80; i++) {
      var s = document.createElement('div');
      s.className = 'star';
      var sz = Math.random() * 2.5 + 0.5;
      s.style.cssText = [
        'width:'    + sz.toFixed(1) + 'px',
        'height:'   + sz.toFixed(1) + 'px',
        'top:'      + Math.random() * 100 + '%',
        'left:'     + Math.random() * 100 + '%',
        '--dur:'    + (Math.random() * 4 + 2).toFixed(1) + 's',
        '--delay:'  + (Math.random() * 5).toFixed(1) + 's',
        'opacity:'  + (Math.random() * 0.5 + 0.1).toFixed(2)
      ].join(';');
      starsEl.appendChild(s);
    }
  }

  /* ─── CART DRAWER ─── */
  var cartOverlay  = document.getElementById('cartOverlay');
  var cartSidebar  = document.getElementById('cartSidebar');
  var cartToggle   = document.getElementById('CartToggle');
  var cartCloseBtn = document.getElementById('cartClose');
  var cartCountEl  = document.getElementById('CartCount');
  var cartItemsEl  = document.getElementById('cartItems');
  var cartFooterEl = document.getElementById('cartFooter');
  var cartTotalEl  = document.getElementById('cartTotal');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartSidebar) cartSidebar.classList.add('open');
    fetchCart();
  }
  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartSidebar) cartSidebar.classList.remove('open');
  }
  if (cartToggle)   cartToggle.addEventListener('click', openCart);
  if (cartOverlay)  cartOverlay.addEventListener('click', closeCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    if (!cartCountEl) return;
    cartCountEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (cartItemsEl) cartItemsEl.innerHTML =
        '<div class="cart-empty">' +
        '<div class="cart-empty-icon">🛒</div>' +
        '<p>Your cart is empty.</p>' +
        '<a href="/collections/all" class="add-to-cart" style="width:auto;padding:.6rem 1.5rem;display:inline-block;">Browse Products</a>' +
        '</div>';
      if (cartFooterEl) cartFooterEl.style.display = 'none';
      return;
    }

    if (cartItemsEl) {
      cartItemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + item.title + '"/>'
          : '<img src="' + window.__homelandLogoUrl + '" alt="HomeLand Peptides"/>';
        return '<div class="cart-item">' +
          '<div class="cart-item-img">' + img + '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + (item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '') + '</div>' +
            '<div class="cart-item-price">$' + (item.price / 100).toFixed(2) + ' × ' + item.quantity + '</div>' +
          '</div>' +
          '<button class="cart-item-remove" data-key="' + item.key + '">✕ Remove</button>' +
        '</div>';
      }).join('');

      cartItemsEl.querySelectorAll('.cart-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeFromCart(btn.dataset.key);
        });
      });
    }

    if (cartTotalEl)  cartTotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    if (cartFooterEl) cartFooterEl.style.display = 'block';
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCartDrawer(cart); })
    .catch(function () {});
  }

  /* ─── AJAX ADD TO CART ─── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('atc-form') && form.id !== 'AddToCartForm') return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        showToast('Added to Cart', item.product_title + ' has been added.');
        fetchCart();
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      })
      .catch(function () {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
  });

  /* ─── TOAST ─── */
  window.showToast = function (title, sub) {
    var t  = document.getElementById('toast');
    var tt = document.getElementById('toastTitle');
    var ts = document.getElementById('toastSub');
    if (!t) return;
    if (tt) tt.textContent = title;
    if (ts) ts.textContent = sub || '';
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 3800);
  };

  /* ─── FAQ ACCORDION ─── */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('click', function () {
      // Close siblings
      var siblings = document.querySelectorAll('.faq-item');
      siblings.forEach(function (s) { if (s !== item) s.classList.remove('open'); });
      item.classList.toggle('open');
    });
  });

  /* ─── MOBILE NAV ─── */
  var hamburger = document.getElementById('Hamburger');
  var mainNav   = document.getElementById('MainNav');
  if (hamburger && mainNav) {
    hamburger.addEventListener('click', function () {
      mainNav.classList.toggle('mobile-open');
    });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!hamburger.contains(e.target) && !mainNav.contains(e.target)) {
        mainNav.classList.remove('mobile-open');
      }
    });
  }

  /* ─── SCROLL REVEAL ─── */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ─── INIT CART COUNT ─── */
  fetchCart();

  window.fetchCart = fetchCart;
  window.openCart  = openCart;

  /* ─── DRAG CAROUSEL ─── */
  (function() {
    function initDragCarousel(wrapperId, trackId, speed) {
      var wrapper = document.getElementById(wrapperId);
      var track   = document.getElementById(trackId);
      if (!wrapper || !track) return;

      var pos = 0, halfWidth = 0, auto = true, dragging = false;
      var startX = 0, startPos = 0, resumeTimer = null;

      // Clone slides until track is at least 3x the wrapper width for seamless loop
      function ensureEnoughClones() {
        var ww = wrapper.offsetWidth || 400;
        var origSlides = Array.from(track.children);
        if (!origSlides.length) return;
        // Keep cloning until scrollWidth is > 3x wrapperWidth
        var attempts = 0;
        while (track.scrollWidth < ww * 3 && attempts < 10) {
          origSlides.forEach(function(slide) {
            track.appendChild(slide.cloneNode(true));
          });
          attempts++;
        }
        halfWidth = track.scrollWidth / 2;
      }

      function getHalf() {
        halfWidth = track.scrollWidth / 2;
      }

      ensureEnoughClones();
      window.addEventListener('load', function() { ensureEnoughClones(); });
      setTimeout(function() { ensureEnoughClones(); }, 500);
      setTimeout(function() { ensureEnoughClones(); }, 1500);

      function pauseResume(delay) {
        auto = false;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function() { auto = true; }, delay || 2500);
      }

      function step() {
        if (auto && !dragging && halfWidth > 0) {
          pos += speed;
          if (pos >= halfWidth) pos = pos - halfWidth; // seamless wrap
          track.style.transform = 'translateX(-' + pos + 'px)';
        }
        requestAnimationFrame(step);
      }
      step();

      wrapper.addEventListener('mouseenter', function() { auto = false; });
      wrapper.addEventListener('mouseleave', function() { if (!dragging) auto = true; });

      wrapper.addEventListener('mousedown', function(e) {
        dragging = true; startX = e.clientX; startPos = pos;
        wrapper.classList.add('dragging'); pauseResume(2500); e.preventDefault();
      });
      document.addEventListener('mousemove', function(e) {
        if (!dragging) return;
        pos = (((startPos + (startX - e.clientX)) % halfWidth) + halfWidth) % halfWidth;
        track.style.transform = 'translateX(-' + pos + 'px)';
      });
      document.addEventListener('mouseup', function() {
        if (!dragging) return;
        dragging = false; wrapper.classList.remove('dragging'); pauseResume(2500);
      });

      var txStart = 0, txPos = 0;
      wrapper.addEventListener('touchstart', function(e) {
        txStart = e.touches[0].clientX; txPos = pos; pauseResume(3000);
      }, { passive: true });
      wrapper.addEventListener('touchmove', function(e) {
        pos = (((txPos + (txStart - e.touches[0].clientX)) % halfWidth) + halfWidth) % halfWidth;
        track.style.transform = 'translateX(-' + pos + 'px)';
      }, { passive: true });
      wrapper.addEventListener('touchend', function() { pauseResume(3000); });
    }

    initDragCarousel('bestSellersWrapper', 'bestSellersTrack', 0.25);
    initDragCarousel('youMayLikeWrapper',  'youMayLikeTrack',  0.25);
  })();

})();

  /* ─── SHUFFLE CAROUSELS ON LOAD ─── */
  function shuffleCarousel(trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;
    // Collect unique slides (first half — before clones)
    var allSlides = Array.from(track.children);
    var half = Math.floor(allSlides.length / 2);
    var originals = allSlides.slice(0, half || allSlides.length);
    // Fisher-Yates shuffle
    for (var i = originals.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = originals[i]; originals[i] = originals[j]; originals[j] = tmp;
    }
    // Rebuild track with shuffled originals + their clones
    track.innerHTML = '';
    originals.forEach(function(s) { track.appendChild(s); });
    originals.forEach(function(s) { track.appendChild(s.cloneNode(true)); });
  }

  document.addEventListener('DOMContentLoaded', function() {
    shuffleCarousel('bestSellersTrack');
    shuffleCarousel('youMayLikeTrack');
  });

